<template>
  <b-card
    class="cursor-pointer"
    no-body
    text-variant="white"
    img-alt="card img"
  >
    <b-card-body class="statistics-body bg-overlay">
      <div class="d-flex justify-content-between mb-3">
        <b-media no-body>
          <b-media-aside

            class="mr-2"
          >
            <b-avatar
              size="26"
              variant="success"
            >
              <feather-icon icon="CheckSquareIcon" />
            </b-avatar>
          </b-media-aside>
          <b-media-body class="my-auto">
            <h5 class="font-weight-bolder mb-0">
              {{ group.name }}
            </h5>
          </b-media-body>
        </b-media>
        <b-button
          v-if="noLabel"
          variant="flat-warning"
          class="btn-icon rounded-circle"
          @click="$emit('onEditButtonClicked',group)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-button>

      </div>
      <b-media
        class="mb-3"
        no-body
      >
        <b-media-aside
          class="mr-2"
        >
          <b-avatar
            size="26"
            variant="light-danger"
          >
            <feather-icon icon="UsersIcon" />
          </b-avatar>
        </b-media-aside>
        <b-media-body class="my-auto">
          <h6 class="mb-0 font-medium-1">
            {{ $t("contact count") }} : {{ group.contact }}
          </h6>
        </b-media-body>
      </b-media>
      <div class="demo-inline-spacing justify-content-center">
        <b-button
          v-if="noLabel"
          variant="gradient-success"
          class="btn-icon"
          @click="$router.push({name:'contacts-import',params:{id:group.id}})"
        >
          <span v-if="noLabel">
            {{ $t('add contacts') }}
          </span>
          <feather-icon icon="UserPlusIcon" />
        </b-button>
        <b-button
          v-if="noLabel"
          variant="gradient-warning"
          class="btn-icon"
          @click="$router.push({name:'contacts-group',params:{id:group.id}})"
        >
          <span v-if="noLabel">
            {{ $t('view contacts') }}
          </span>
          <feather-icon icon="SearchIcon" />
        </b-button>
        <b-button
          v-if="noLabel"
          variant="gradient-danger"
          class="btn-icon mr-0"
          @click="$emit('onDeleteButtonClicked',group)"
        >
          <span v-if="noLabel">
            {{ $t('Delete') }}
          </span>
          <feather-icon icon="TrashIcon" />
        </b-button>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>

import {
  BCard, BCardBody, BMedia, BMediaAside, BAvatar, BMediaBody, BButton,
} from 'bootstrap-vue'

export default {
  name: 'GroupCard',
  components: {
    BCard, BCardBody, BMedia, BMediaAside, BAvatar, BMediaBody, BButton,
  },
  props: {
    group: {
      type: Object,
      default: () => {},
    },
    noLabel: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>

</style>
